module.exports = __webpack_public_path__ + "img/imgconcancelbt.bff055ee.png";